import CustomersPage from "../../pages/legacy/customers/CustomersPage";

const route = {
  key: "customers",
  path: "/legacy/customers",
  component: CustomersPage,
  private: true,
  layout: "main",
  icon: "faUsers",
  group: "sales",
  order: 10,
  permission: "legacy.customers.read"
};

export default route;